import { render } from "./MatchingLocations.vue?vue&type=template&id=aca2f838&ts=true"
import script from "./MatchingLocations.vue?vue&type=script&lang=ts"
export * from "./MatchingLocations.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__